<div ngbDropdownMenu>
  <div class="mb-1 filter-container" *ngIf="showFilter">
    <input
      #filterInput
      type="text"
      class="form-control"
      [(ngModel)]="filterText"
      placeholder="Start typing to filter the list"
      (ngModelChange)="onFilterChange()"
      (keydown)="onKeyDownFilterInput($event)" />
    <a href="#" (click)="clearFilter()" class="clear-button" *ngIf="searchTerm$ | async">
      <i class="bi bi-x-lg"></i>
    </a>
  </div>

  <tx-loader-wrapper [isLoading]="isLoading">
    <div class="items-list">
      <ul class="txui-menu txui-widget txui-widget-content txui-corner-all" role="menu" #itemsList>
        <li
          class="txui-menu-item-small txui-menu-item"
          role="presentation"
          *ngFor="let item of filteredItems; let i = index">
          <a
            class="txui-corner-all"
            role="menuitem"
            ngbDropdownItem
            [id]="'item-' + item[idField]"
            (click)="onSelectItem(item)"
            (keydown)="onKeyDownItem($event, item, i)">
            <div class="small-menu-item-caption-container">
              <p>{{ item[titleField] }}</p>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </tx-loader-wrapper>
</div>
